import { Dialog } from '@mui/material';
import React, { useState } from 'react';
import { ReactComponent as CrossIcon } from "../../../../../../assets/img/svg/CrossIcon.svg";
import { ReactComponent as InfoIcon } from "../../../../../../assets/img/svg/InfoCircleRedFilled.svg";
import AInput from '../../../common/formFeilds/customInput/AInput';
import AButton from '../../../common/form-fields-mui/AButton';
import { inputStyles, labelStyles } from './utils';
import ALoader from '../../../common/a-loader';



const SearchResultDialog = ({
    open,
    setOpen,
    searchResultByRollNo,
    setResultInfo,
    apiLoader
}) => {

    const [rollNo, setRollNo] = useState('');
    const [errMsg, setErrMsg] = useState('');

    const handleClose = () => {
        setOpen(false);
        setRollNo('');
        setResultInfo({})
    }

    return (
        <Dialog
            maxWidth="xs"
            fullWidth
            open={open}
        >
            <div className='p-3'>
                {apiLoader && <ALoader />}
                <div className='d-flex justify-content-between'>
                    <h2 className='mb-2'>Add a new result</h2>
                    <CrossIcon onClick={handleClose} />
                </div>

                <AInput
                    placeholder="Enter Roll no."
                    label="Roll no."
                    labelStyle={labelStyles}
                    style={inputStyles}
                    value={rollNo}
                    handler={val => setRollNo(val)}
                    type='number'
                />

                <AButton
                    variant='primary_filled'
                    className='no-ml-btn mt-2'
                    onClick={() => searchResultByRollNo(rollNo , 'add', setErrMsg)}
                >
                    Check Result
                </AButton>

                {errMsg &&
                    <div className='mt-1'>
                        <InfoIcon className='mr-2' />
                        <span className='error-msg'>
                            {errMsg}
                        </span>
                    </div>
                }

            </div>

        </Dialog>
    );
}

export default SearchResultDialog;